import Epic from 'components/framework/models/Epic';
import Feature from 'components/framework/models/Feature';
import Requirement from 'components/framework/models/Requirement';
import Initiative from 'components/framework/models/Initiative';

const RECORD_CLASSES = {
  Epic,
  Feature,
  Requirement,
  Initiative,
} as const;

export type RecordTypes = keyof typeof RECORD_CLASSES;

export default async function flagRecord(
  recordType: RecordTypes,
  recordId: string,
  manualRiskComment: string | null = null
) {
  const record = new RECORD_CLASSES[recordType]({ id: recordId });

  await record.flagAsAtRisk(manualRiskComment);
}
